export var KeyBoardKeys;
(function (KeyBoardKeys) {
    KeyBoardKeys["Escape"] = "Escape";
    KeyBoardKeys["Enter"] = "Enter";
    KeyBoardKeys["ArrowUp"] = "ArrowUp";
    KeyBoardKeys["ArrowDown"] = "ArrowDown";
    KeyBoardKeys["ArrowLeft"] = "ArrowLeft";
    KeyBoardKeys["ArrowRight"] = "ArrowRight";
    KeyBoardKeys["Space"] = "Space";
    KeyBoardKeys["Home"] = "Home";
    KeyBoardKeys["End"] = "End";
    KeyBoardKeys["Tab"] = "Tab";
})(KeyBoardKeys || (KeyBoardKeys = {}));
